export default [
  "Exclusive",
  "Limited Edition",
  "Tone",
  "Alert Tone",
  "Text Tone",
  "Ringtone",
  "Ringtone Version",
  "E-Release",
  "Digital Only",
  "Digital Download",
  "Digital Single",
  "E-Album",
  "2 CD Set",
  "With Lyrics",
  "Clips from",
  "Official Music Video",
  "Full Song Video",
  "Full Version",
  "Original",
  "Clean Version",
  "Explicit",
  "Explicit Version",
  "ft.",
  "feat.",
  "featuring",
  "[",
  "]"
]